import React, { memo, useMemo } from 'react'

import { Image2, Text, View360Arrow } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, shape, func, bool,
} from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import TabButton from './Components/TabButton/TabButton'

function Tabs({ tabs }) {
  const t = useTranslation()
  const { image, multiView, text } = tabs

  const buttons = useMemo(() => [
    {
      id: image.id,
      label: t(multiView ? 'shared.actionSelector.tabs.singleImage' : 'shared.actionSelector.tabs.image'),
      icon: Image2,
      onClick: image.onClick,
      isActive: image.isActive,
    },
    ...(multiView ? [{
      id: multiView.id,
      label: t('shared.actionSelector.tabs.multiView'),
      icon: View360Arrow,
      onClick: multiView.onClick,
      isActive: multiView.isActive,
      tooltip: t('shared.actionSelector.tabs.multiViewTooltip'),
    }] : []),
    {
      id: text.id,
      label: t('shared.actionSelector.tabs.text'),
      icon: Text,
      onClick: text.onClick,
      isActive: text.isActive,
    },
  ], [t, tabs])

  return (
    <div className="action-selector__tabs">
      {buttons.map(button => <TabButton key={button.id} {...button} />)}
    </div>
  )
}

Tabs.propTypes = {
  tabs: shape({
    image: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
    }).isRequired,
    multiView: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
    }),
    text: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
    }).isRequired,
  }).isRequired,
}

export default memo(Tabs)
